import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';

const ERROR_MESSAGE = 'Failed to create order';

/**
 * @typedef CreateOrderInput
 * @property {string} projectId
 * @property {string} variationId
 * @property {string} packageType
 * @property {string} source
 * @property {string} [topLevelSource]
 * @property {string} brandName
 * @property {string} slogan
 * */

/**
 * @typedef CreateOrderOutput
 * @property {('post_order_page'|'payment_session_creation')} redirect
 * @property {string} redirectId
 * @property {string} [contextId]
 * */

/**
 * Creates order
 * @param {CreateOrderInput} input - order to create params
 * @return {Promise<Object>}
 * */
const createOrder = async (input) => {
    const requestUrl = pathfinder('logo_maker_makers_create_v_2_order');

    try {
        const { data } = await axios.post(requestUrl, input);
        if (data.error) {
            throw new Error(data.error);
        }

        return data.data;
    } catch (e) {
        logAPIError(e, {
            message: ERROR_MESSAGE,
            input,
        });
    }
};

export default createOrder;
